// import { legacy_createStore as createStore } from 'redux'

// const initialState = {
//   sidebarShow: true,
//   theme: 'light',
// }

// const changeState = (state = initialState, { type, ...rest }) => {
//   switch (type) {
//     case 'set':
//       return { ...state, ...rest }
//     default:
//       return state
//   }
// }

// const store = createStore(changeState)
// export default store




import { legacy_createStore as createStore } from 'redux'

const initialState = {
  sidebarShow: true,
  theme: 'light',
  // YENİ: Varsayılan boş bir config ekliyoruz
  themeConfig: {
    logo: null,
    primaryColor: null
  }
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    
    // YENİ: Backend'den gelen config'i store'a yazan komut
    case 'SET_THEME_CONFIG':
      return { ...state, themeConfig: rest.payload }
      
    default:
      return state
  }
}

const store = createStore(changeState)
export default store